import { c as _c } from "react/compiler-runtime";
import { Icon } from "@justhome/react-ui";
import Link from "@components/LocaleLink";
import { FC } from "react";
interface ContactItemProps {
  icon: any;
  label: string;
  href: string;
  value: string;
}
const ContactItem: FC<ContactItemProps> = t0 => {
  const $ = _c(13);
  const {
    icon,
    label,
    href,
    value
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = <Icon icon={icon} size={32} theme="outline" className="bg-primary-800 text-neutral-0 p-s rounded-s" />;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label) {
    t2 = <span className="text-body-1 font-medium">{label}</span>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== href || $[5] !== value) {
    t3 = <Link href={href} className="text-body-2 text-primary-800 hover:text-primary-875">{value}</Link>;
    $[4] = href;
    $[5] = value;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="flex flex-col gap-xs">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t4) {
    t5 = <div className="flex gap-s">{t1}{t4}</div>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default ContactItem;